/* ft-fzwahl.js (05.10.2026, Sitzung Webshop, Ladezeit des Kopfes): Skript der Fahrzeugwahl (snippets/ft-kat-fahrzeugwahl),
   vorher in jedem Exemplar inline (auf der Startseite dreimal). Eingebunden einmal aus sections/ft-header.liquid mit defer,
   richtet alle Exemplare der Seite ein. Die Markendaten (rund 22 KB) kommen erst bei Bedarf, siehe datenHolen(). */
(function () {
  if (window.ftFzwahlGeladen) return;
  window.ftFzwahlGeladen = true;
  /* 02.10.2026 abends (Pascal: „man sollte noch einen Suche-bestätigen-Knopf einbauen und einen Indikator, falls man schon eins
     ausgesucht hat“): Die Wahl springt nicht mehr von selbst weiter, sondern erst mit „Passende Teile anzeigen“. Ist ein Fahrzeug
     gemerkt, sind die drei Felder damit vorbelegt und tragen einen Haken; darüber steht „Ihr Fahrzeug“ mit ✕. */
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function jahre(j) { var s = String(j || '').trim(); var m = s.match(/^(\S+)\s*-\s*(\S*)$/); return m ? (m[2] ? m[1] + ' bis ' + m[2] : 'ab ' + m[1]) : s; }
  function motorText(e) { return e.m + ', ' + e.ps + (e.cc ? ', ' + e.cc : '') + (e.j ? ', ' + jahre(e.j) : ''); }
  var cache = {};
  function laden(url) {
    if (cache[url]) return Promise.resolve(cache[url]);
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d && d.format === 2) cache[url] = d; return d; })
      .catch(function () { return null; });
  }
  /* 05.10.2026 (Ladezeit des Kopfes): Markendaten erst bei Bedarf. Einmal je Seite geholt (alle Exemplare teilen das
     Versprechen), für die Sitzung gemerkt (sessionStorage, Schlüssel je Theme, sonst mischen Vorschau und Live). Steht noch
     ein alter Datenblock in der Seite (Seite aus dem Zwischenspeicher), wird der genommen. Scheitert das Holen, gilt das
     Versprechen nicht weiter, die nächste Wahl versucht es neu. */
  var datenVersprechen = null;
  function datenHolen() {
    if (datenVersprechen) return datenVersprechen;
    var alt = document.querySelector('[data-ft-fzwahl-daten]');
    if (alt) { try { datenVersprechen = Promise.resolve(JSON.parse(alt.textContent)); return datenVersprechen; } catch (e) {} }
    var schluessel = 'ft_fzwahl_daten_' + ((window.Shopify && Shopify.theme && Shopify.theme.id) || '');
    try {
      var s = window.sessionStorage.getItem(schluessel);
      var g = s ? JSON.parse(s) : null;
      if (g && g.length) { datenVersprechen = Promise.resolve(g); return datenVersprechen; }
    } catch (e) {}
    var wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    datenVersprechen = fetch(wurzel + '?section_id=ft-fzwahl-daten', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('Status ' + r.status); return r.text(); })
      .then(function (html) {
        var k = html.indexOf('data-ft-fzwahl-daten');
        var a = html.indexOf('>', k) + 1;
        var b = html.indexOf('</script>', a);
        if (k < 0 || b < 0) throw new Error('keine Daten');
        var d = JSON.parse(html.slice(a, b));
        if (!d || !d.length) throw new Error('leer');
        try { window.sessionStorage.setItem(schluessel, JSON.stringify(d)); } catch (e) {}
        return d;
      });
    datenVersprechen.catch(function () { datenVersprechen = null; });
    return datenVersprechen;
  }
  function init(box) {
    /* 05.10.2026: Markendaten kommen erst über datenHolen() (Markenwahl oder gemerktes Fahrzeug). */
    var daten = null;
    var F = window.FtFahrzeug || null;
    var marke = box.querySelector('[data-ft-fzwahl-marke]');
    var modell = box.querySelector('[data-ft-fzwahl-modell]');
    var motor = box.querySelector('[data-ft-fzwahl-motor]');
    var los = box.querySelector('[data-ft-fzwahl-los]');
    var mein = box.querySelector('[data-ft-fzwahl-mein]');
    var raster = box.querySelector('.ft-fzwahl');
    var akt = null, ziel = null, ladeNr = 0;
    function neu(text, wert) { var o = document.createElement('option'); o.textContent = text; o.value = wert; return o; }
    /* Für das Auswahlfenster am Handy: Hauptzeile und graue Zusatzzeile */
    function zweiZeilen(o, haupt, zusatz) { o.setAttribute('data-ft-blatt-titel', haupt); if (zusatz) o.setAttribute('data-ft-blatt-zusatz', zusatz); return o; }
    function motorZurueck(text) { motor.innerHTML = ''; motor.appendChild(neu(text, '')); motor.disabled = true; }
    function losSetzen(url, text, fz) {
      ziel = url ? { url: url, fz: fz || null } : null;
      if (!los) return;
      los.disabled = !url;
      los.textContent = (box.closest('[data-tf-bleiben]') && (fz || text === 'Passende Teile anzeigen')) ? 'Fahrzeug übernehmen' : (text || 'Passende Teile anzeigen');
    }
    function gewaehlt(an) { if (raster) raster.classList.toggle('ist-gewaehlt', !!an); }
    /* Marke laden und Modelle füllen; liefert die Daten (Format 2) oder null */
    function markeLaden(wahl) {
      akt = null;
      modell.innerHTML = '';
      motorZurueck('Bitte wählen');
      losSetzen(null);
      gewaehlt(false);
      /* 02.10.2026 (LAYOUT-FIXES Phase 4): ohne Marke sagt das Feld, was zuerst zu tun ist */
      modell.appendChild(neu(wahl !== '' ? 'Wird geladen' : 'Bitte wählen', ''));
      modell.disabled = true;
      if (wahl === '') return Promise.resolve(null);
      var nr = ++ladeNr;
      modell.setAttribute('aria-busy', 'true');
      /* 05.10.2026: erst die Markendaten (einmal je Sitzung), dann wie bisher die Datei der Marke */
      var m = null;
      return datenHolen().then(function (dd) {
        daten = dd;
        m = daten[wahl] || null;
        return m ? laden(m[3]) : 'fehlt';
      }, function () { return 'fehler'; }).then(function (d) {
        if (d === 'fehlt' || d === 'fehler') {
          if (nr === ladeNr) modell.removeAttribute('aria-busy');
          if (marke.value !== wahl) return null;
          modell.innerHTML = '';
          modell.appendChild(neu(d === 'fehler' ? 'Bitte Marke erneut wählen' : 'Bitte wählen', ''));
          if (d === 'fehler') marke.value = '';
          return null;
        }
        if (nr === ladeNr) modell.removeAttribute('aria-busy');
        if (marke.value !== wahl) return null;
        modell.innerHTML = '';
        modell.appendChild(neu('Bitte wählen', ''));
        var alleOpt = neu('Alle Teile für ' + m[0], '/collections/' + m[1]);
        alleOpt.setAttribute('data-ft-blatt-hervor', '');
        modell.appendChild(alleOpt);
        if (d && d.format === 2 && d.modelle && d.modelle.length) {
          akt = d;
          d.modelle.forEach(function (mo, i) { modell.appendChild(zweiZeilen(neu(mo.n + (mo.j ? ', ' + jahre(mo.j) : ''), 'm' + i), mo.n, mo.j ? jahre(mo.j) : '')); });
        } else {
          for (var i = 0; i < m[2].length; i++) { modell.appendChild(neu(m[2][i][0], '/collections/' + m[2][i][1])); }
          if (m[2].length === 0) losSetzen('/collections/' + m[1], 'Alle Teile für ' + m[0] + ' anzeigen');
        }
        modell.disabled = false;
        return akt;
      });
    }
    /* 08.10.2026 (Pascal: Auswahllisten ordentlich sortiert): Motoren nach Motor (Zahlen als Zahlen, 1.0 vor 1.2 vor 2.0), dann
       PS aufsteigend (86 vor 110 PS; die Datei sortiert PS als Text). Der Wert bleibt die Stelle in der Datei. */
    function motorReihe(liste) {
      function zahl(s) { var m = String(s || '').match(/\d+/); return m ? parseInt(m[0], 10) : 0; }
      return liste.map(function (e, i) { return i; }).sort(function (a, b) {
        var x = liste[a], y = liste[b];
        var c = String(x.m || '').localeCompare(String(y.m || ''), 'de', { numeric: true, sensitivity: 'base' });
        return c || (zahl(x.ps) - zahl(y.ps)) || (a - b);
      });
    }
    function motorenFuellen(mo) {
      motor.innerHTML = '';
      motor.appendChild(neu('Bitte wählen', ''));
      motorReihe(mo.motoren).forEach(function (i) { var e = mo.motoren[i]; motor.appendChild(zweiZeilen(neu(motorText(e), String(i)), e.m + ', ' + e.ps, [e.cc, e.j ? jahre(e.j) : ''].filter(Boolean).join(', '))); });
      motor.disabled = false;
    }
    function fahrzeugAus(mo, e) {
      return { marke: akt.marke, modell: mo.n, motor: e.m, ps: e.ps, jahre: e.j,
        code: (e.c && e.c.length === 1) ? e.c[0] : '', ccm: e.cc || '', hsntsn: '' };
    }
    marke.addEventListener('change', function () {
      markeLaden(marke.value).then(function () { if (!modell.disabled) modell.focus(); });
    });
    modell.addEventListener('change', function () {
      var v = modell.value;
      gewaehlt(false);
      if (!v) { motorZurueck('Bitte wählen'); losSetzen(null); return; }
      if (v.charAt(0) === '/') {
        motorZurueck('Bitte wählen');
        losSetzen(v, modell.options[modell.selectedIndex].text.indexOf('Alle Teile für ') === 0 ? modell.options[modell.selectedIndex].text + ' anzeigen' : 'Teile für ' + modell.options[modell.selectedIndex].text + ' anzeigen');
        return;
      }
      var mo = akt && akt.modelle[parseInt(v.slice(1), 10)];
      if (!mo) return;
      motorenFuellen(mo);
      losSetzen(null);
      motor.focus();
    });
    motor.addEventListener('change', function () {
      gewaehlt(false);
      if (!motor.value || !akt) { losSetzen(null); return; }
      var mo = akt.modelle[parseInt(modell.value.slice(1), 10)];
      var e = mo && mo.motoren[parseInt(motor.value, 10)];
      if (!e) { losSetzen(null); return; }
      var fz = fahrzeugAus(mo, e);
      losSetzen(F ? F.url(fz) : '/collections/' + (daten && daten[marke.value] ? daten[marke.value][1] : ''), 'Passende Teile anzeigen', fz);
      if (los) los.focus();
    });
    /* 14.10.2026 abends (Testshop-Umbau): Im Teilefinder der Produktseite (data-tf-bleiben) merkt die Wahl nur das Fahrzeug und bleibt
       auf der Seite, der Prüfer der Produktseite antwortet über das Ereignis „ft-fahrzeug“ */
    var bleiben = !!box.closest('[data-tf-bleiben]');
    if (bleiben && los) los.textContent = 'Fahrzeug übernehmen';
    if (los) los.addEventListener('click', function () {
      if (!ziel) return;
      if (ziel.fz && F) F.schreiben(ziel.fz);
      if (bleiben && ziel.fz) { los.textContent = 'Fahrzeug gemerkt'; return; }
      window.location.href = ziel.url;
    });
    /* Gemerktes Fahrzeug: Felder vorbelegen, Haken zeigen */
    function vorbelegen(v) {
      if (!v || !F) return;
      /* 05.10.2026: erst die Markendaten holen (bei gemerktem Fahrzeug gleich beim Laden, danach aus der Sitzung).
         Hat jemand inzwischen selbst eine Marke gewählt, bleibt seine Wahl stehen. */
      var startWert = marke.value;
      datenHolen().then(function (dd) { daten = dd; if (marke.value === startWert) vorbelegenMit(v); }, function () {});
    }
    function vorbelegenMit(v) {
      var wahl = -1;
      for (var i = 0; i < daten.length; i++) { if (daten[i][1] === 'fahrzeug-' + F.slug(v.marke)) { wahl = i; break; } }
      if (wahl < 0) return;
      marke.value = String(wahl);
      markeLaden(String(wahl)).then(function (d) {
        if (!d) return;
        var mi = -1;
        d.modelle.some(function (mo, i) { if (F.norm(mo.n) === F.norm(v.modell)) { mi = i; return true; } return false; });
        if (mi < 0) return;
        modell.value = 'm' + mi;
        var mo = d.modelle[mi];
        motorenFuellen(mo);
        var ei = -1;
        mo.motoren.some(function (e, i) {
          var ok = F.norm(e.m) === F.norm(v.motor) && F.norm(e.ps) === F.norm(v.ps) && (!v.jahre || !e.j || F.norm(e.j) === F.norm(v.jahre));
          if (ok) { ei = i; return true; }
          return false;
        });
        if (ei < 0) return;
        motor.value = String(ei);
        losSetzen(F.url(v), 'Passende Teile anzeigen', null);
        gewaehlt(true);
      });
    }
    function meinZeigen(v) {
      if (!mein) return;
      if (!v || !F) { mein.hidden = true; mein.innerHTML = ''; return; }
      mein.innerHTML = '<span class="ft-fzwahl-mein-haken" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>' +
        '<span class="ft-fzwahl-mein-text"><strong>Ihr Fahrzeug:</strong> ' + esc(F.text(v)) + '</span>' +
        '<a class="ft-kopf-link" href="' + esc(F.url(v)) + '">Passende Teile ansehen</a>' +
        '<button type="button" class="ft-fzwahl-mein-weg" aria-label="Fahrzeug vergessen"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg></button>';
      mein.hidden = false;
    }
    if (F) {
      var v0 = F.lesen();
      meinZeigen(v0);
      vorbelegen(v0);
      window.addEventListener('ft-fahrzeug', function (e) {
        meinZeigen(e.detail);
        if (!e.detail) { marke.value = ''; markeLaden(''); }
      });
      box.addEventListener('click', function (e) { if (e.target.closest('.ft-fzwahl-mein-weg')) F.loeschen(); });
    }
    /* 05.10.2026: Daten schon holen, sobald jemand das Markenfeld antippt, damit die Modelle ohne Wartezeit kommen. */
    function vorladen() { datenHolen().catch(function () {}); }
    marke.addEventListener('focus', vorladen);
    marke.addEventListener('pointerdown', vorladen, { passive: true });
    /* Läuft erst nach dem Seitenaufbau (defer): Wer vorher schon eine Marke gewählt hat (oder der Browser hat sie beim
       Zurückgehen wiederhergestellt), bekommt die Modelle jetzt. */
    if (marke.value !== '' && !(F && F.lesen())) markeLaden(marke.value);
    /* 14.10.2026 abends (Testshop-Umbau, EIN Teilefinder): Auf Marken- und Modellseiten beginnt die Wahl mit Marke und Modell der
       Seite (snippets/ft-teilefinder, data-tf-marke und data-tf-modell). Ein gemerktes Fahrzeug geht vor. */
    var vor = box.closest('[data-tf-marke]');
    if (vor && !(F && F.lesen())) {
      var vMarke = vor.getAttribute('data-tf-marke'), vModell = vor.getAttribute('data-tf-modell') || '';
      var vListe = (vor.getAttribute('data-tf-modelle') || '').split(';;').map(function (x) { return x.trim(); }).filter(Boolean);
      datenHolen().then(function (dd) {
        daten = dd;
        if (marke.value !== '') return;
        var wahl = -1;
        for (var i = 0; i < daten.length; i++) { if (daten[i][1] === 'fahrzeug-' + vMarke) { wahl = i; break; } }
        if (wahl < 0) return;
        marke.value = String(wahl);
        markeLaden(String(wahl)).then(function (d) {
          var nn = function (s) { return F ? F.norm(s) : String(s || '').toLowerCase(); };
          /* Modellseiten: im Modellfeld nur die Baureihen der Seite; bei genau einer ist sie gewählt */
          if (d && vListe.length) {
            var erlaubt = vListe.map(nn), rest = [];
            [].slice.call(modell.options).forEach(function (o) {
              if (o.value.charAt(0) !== 'm') return;
              var mo = d.modelle[parseInt(o.value.slice(1), 10)];
              if (mo && erlaubt.indexOf(nn(mo.n)) === -1) o.parentNode.removeChild(o); else rest.push(o);
            });
            if (rest.length === 1 && !vModell) vModell = d.modelle[parseInt(rest[0].value.slice(1), 10)].n;
          }
          if (!d || !vModell) return;
          var mi = -1;
          d.modelle.some(function (mo, k) { if (nn(mo.n) === nn(vModell)) { mi = k; return true; } return false; });
          if (mi < 0) return;
          modell.value = 'm' + mi;
          motorenFuellen(d.modelle[mi]);
        });
      }, function () {});
    }
  }
  var alle = document.querySelectorAll('[data-ft-fzwahl]');
  for (var i = 0; i < alle.length; i++) { if (!alle[i].hasAttribute('data-ft-fzwahl-an')) { alle[i].setAttribute('data-ft-fzwahl-an', ''); init(alle[i]); } }
})();
